import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import { Button, Col, Container, FormGroup, Label, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import {
  GetQuestionTypeRow,
  UpdateQuestionTypeData,
} from "../../services/QuestionsService";
import { GetVacancyTypeList } from "../../services/VacancyTypeServices";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";

function EditQuestionType() {
  const [formDataValues, setFormDataValues] = useState({});
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setStatus] = useState([
    { label: "Active", value: "1", id: "1" },
    { label: "Inactive", value: "0", id: "0" },
  ]);

  const { id } = useParams();

  useEffect(() => {
    GetQuestionTypeRow(id)
      .then(res => {
        if (res?.data?.status) {
          setFormDataValues(res?.data?.data);
        }
      })
      .catch(err => {
        setErrors({ message: "No data available", error: err });
      });
  }, [id]);

  const handleChangeStatusValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      status: e?.id,
    }));
  };
  const handleStatusOptionSelection = id => {
    if (status) {
      let record = status?.find(items => items?.id == id);
      return record;
    } else {
      return null;
    }
  };

  /* Handle Change Event */
  const handleChange = e => {
    const { name, value } = e.target;
    setFormDataValues({
      ...formDataValues,
      [name]: value,
    });
  };

  // Validation logic for each field
  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    if (!formDataValues.ques_type.trim()) {
      newErrors.ques_type = "Questions Type is required";
      isValid = false;
    }
    if (!formDataValues.status) {
      newErrors.status = "status Type is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Submit the form data or perform other actions
  const handleSubmit = async e => {
    if (validateForm()) {
      let data = {
        ques_type: e?.ques_type,
        status: e?.status,
      };

      UpdateQuestionTypeData(data, id)
        .then(res => {
          if (res?.status === 200) {
            toast.success(res?.data?.message);
            window.location.href = "/question-type-list";
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(err => {
          //console.error('Error creating question type:', err);
          setErrors("Failed to create question type.");
        });
    } else {
      console.error("Form has errors");
    }
  };

  if (!checkPermissionStatus("question-type-list", "edit")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {/* <MetaTags><title>Create Question Type</title></MetaTags> */}

        <Row className="mb-3 align-items-center border-bottom py-2 pt-0">
          <Col lg="6" md="6">
            <h5 className="text-uppercase heading-one mb-0">
              EDIT QUESTION TYPE
            </h5>
          </Col>

          <Col lg="6" md="6">
            <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
              <Link to="/question-type-list" className="btn btn-primary">
                Back To Listing
              </Link>
            </div>
          </Col>
        </Row>

        <div className="form-details-section mt-3">
          <Container fluid>
            {/* <Breadcrumbs title="Question Type" breadcrumbItem="Edit Question Type" /> */}
            <Row>
              <Col lg="12">
                <AvForm
                  className="outer-repeater"
                  onValidSubmit={() => {
                    handleSubmit(formDataValues);
                  }}
                >
                  <div data-repeater-list="outer-group" className="outer">
                    <div data-repeater-item className="outer">
                      {successMessage && (
                        <div class="alert alert-success" role="alert">
                          {successMessage}
                        </div>
                      )}
                      {errorMessage && (
                        <div class="alert alert-danger" role="alert">
                          {errorMessage}
                        </div>
                      )}

                      <Row>
                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ques_type"
                              className="col-form-label"
                            >
                              Question Type
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="ques_type"
                              name="ques_type"
                              placeholder="Question Type"
                              errorMessage="Question Type Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Question Type is required",
                                },
                                minLength: {
                                  value: 2,
                                  errorMessage:
                                    "Question Type must be at least 2 characters",
                                },
                                maxLength: {
                                  value: 50,
                                  errorMessage:
                                    "Question Type cannot exceed 50 characters",
                                },
                              }}
                              value={formDataValues?.ques_type || ""}
                              onChange={handleChange}
                            />
                            <div className="error">{errors.ques_type}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label className="col-form-label">
                              Status<span className="text-danger">*</span>
                            </Label>
                            <Select
                              className="mb-2"
                              placeholder="Select Status"
                              id="status_id"
                              name="status"
                              validate={{ required: { value: true } }}
                              options={status}
                              value={handleStatusOptionSelection(
                                formDataValues?.status
                              )}
                              onChange={handleChangeStatusValuePopulate}
                            />
                            {errors.status && (
                              <div className="error">{errors.status}</div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>

                      <div className="cta text-center gap-1 d-flex justify-content-center mt-4 mb-4">
                        <Button
                          type="submit"
                          className="btn btn-primary"
                          color="success"
                        >
                          Submit
                        </Button>
                        &nbsp;
                        <Button
                          type="button"
                          className="btn btn-secondary"
                          onClick={e => {
                            e.preventDefault();
                            window.location.href = "/question-type-list";
                          }}
                        >
                          {" "}
                          Cancel
                        </Button>
                      </div>
                    </div>
                  </div>
                </AvForm>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
}

export default EditQuestionType;
